import { useRef, useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import ComparisonProductCard from "./ComparisonProductCard";
import ComparisonProductSkeletonLoad from "./ComparisonProductSkeletonLoad";

export default function ComparisonProductList({ products = [], labels = [],bestValueProducts=[],partialData=[],phoneNumber }) {

  const rowRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    if (!rowRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = rowRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  useEffect(() => {
    checkScroll();
    const el = rowRef.current;
    if (!el) return;

    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [products]);

  const scrollLeft = () => {
    rowRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    rowRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  if (!products || products?.length === 0) {
    return null;
  }

  // Add this function before your Row component
const getUniqueProducts = (products, bestValueProducts) => {
  if (!bestValueProducts || bestValueProducts?.length === 0) return [];

  const uniqueProducts = [];
  const seenKeys = new Set();

  // Check in display order: Highest Rated (0), Lowest Price (1), Best Value (2)
  // But Best Value has priority when there are duplicates
  [0, 1, 2].forEach(idx => {
    const product = bestValueProducts[idx];
    if (product && product.key) {
      // If this is a duplicate
      if (seenKeys.has(product.key)) {
        // Only skip if it's NOT the Best Value (index 2)
        // If it IS Best Value, we still want to show it (replacing the earlier one)
        if (idx === 2) {
          // Remove the earlier duplicate and add Best Value instead
          const duplicateIdx = uniqueProducts.findIndex(p => p.product.key === product.key);
          if (duplicateIdx !== -1) {
            uniqueProducts.splice(duplicateIdx, 1);
          }
          uniqueProducts.push({ product, originalIndex: idx });
        }
        // If it's index 0 or 1 and duplicate, skip it
      } else {
        // Not a duplicate, add it
        uniqueProducts.push({ product, originalIndex: idx });
        seenKeys.add(product.key);
      }
    }
  });

  return uniqueProducts;
};

// Then modify your Row component like this:
const uniqueProducts = getUniqueProducts(products, bestValueProducts);
const productCount = uniqueProducts?.length;

// Calculate responsive column spans
const getColumnSpan = (count) => {
  if (count === 1) return { xs: 24, md: 12, lg: 8 }; // Full width on mobile, half on tablet, 1/3 on desktop
  if (count === 2) return { xs: 12, md: 12, lg: 12 }; // Half width on mobile, half on tablet/desktop
  return { xs: 8, md: 8, lg: 8 }; // Original: 1/3 width on all screens
};

const columnSpan = getColumnSpan(productCount);



  return (
    <>
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection:"row",
        marginBottom: "0.2rem",
      }}
    >
      {/* Fixed Label Column */}
     
      <div class={uniqueProducts?.length ===3 || partialData?.length >0 ? "comaprisonLabel" : "comaprisonLabel2"} style={{ flex: "0 0 auto",paddingTop:"20px" }}>
        {partialData?.length >0 ?
        <ComparisonProductSkeletonLoad partialData={partialData}/>
        :
        <ComparisonProductCard product={{}} isLabel={true} labels={labels} featureKey={products?.[0]?.["best_for_label"]} phoneNumber={phoneNumber} unitValue={bestValueProducts?.[0]?.["unit"]}/>
      }
      </div>

      {/* Scrollable Products */}
      <section className="product-row" style={{width:"81%",paddingLeft:"4px"}}>
        <Row
  gutter={[4, 4]}
  ref={rowRef}
  className="product-row-inner"
  style={{
    flexDirection:"row",
    paddingTop:"20px",
    paddingBottom:"40px",
    width:"100%",
    // justifyContent: productCount < 3 ? "center" : "flex-start" // Center when less than 3 cards
  }}
>

  {partialData?.length === 0 ? uniqueProducts?.map(({ product, originalIndex }, displayIdx) => (
    <Col
      key={`${product?.key || originalIndex}-${displayIdx}`}
      className="product-col"
      {...columnSpan}
    >
      <ComparisonProductCard
        product={products[originalIndex]}
        isLabel={false}
        labels={labels}
        bestValue={product}
        productIndex={originalIndex}
        partialData={partialData}
        phoneNumber={phoneNumber}
        unitValue={product?.unit || ""}
      />
    </Col>
  ))
  :
  products?.map((product, idx) => (

          <Col
          className="product-col"
          style={{}}

          xs={8} md={8} lg={8}
        >

            <ComparisonProductCard
              product={product}
              isLabel={false}
              labels={labels}
              bestValue={bestValueProducts[idx]}
              productIndex={idx}
              partialData={partialData}
              phoneNumber={phoneNumber}
              unitValue=""
            />
          </Col>
        ))
}
</Row>
      {/* {canScrollLeft && (
        <Button
          onClick={scrollLeft}
          className="pd-slide-btn-left"
          shape="circle"
          icon={<LeftOutlined />}
        />
      )}
      {canScrollRight && (
        <Button
          onClick={scrollRight}
          className="pd-slide-btn-right"
          shape="circle"
          icon={<RightOutlined />}
        />
      )} */}
      </section>

      {/* Scroll Buttons */}

    </div>
    <div>

    </div>
    </>
  );
}
